import {
  ConstantsBaseClinic,
  EnvironmentBaseConstants,
  EnvironmentBaseConstantsCMSUI,
  EnvironmentBaseConstantsPIMS,
  EnvironmentName,
  SharedApiUrls, SharedThirdPartyKeys
} from '../environments.model';

const BASE_CONSTANTS: EnvironmentBaseConstants = {
  platform: 'web',
};

export const CONSTANTS_PIMS: EnvironmentBaseConstantsPIMS = {
  ...BASE_CONSTANTS,
  app_name: 'pims',
  version: '__PIMS_APP_VERSION__',
  CLOUDFLARE_ACCESS_CLIENT_ID: 'a5659d47e0cfb7d8519ec671f05a2e8a.access',
  CLOUDFLARE_ACCESS_CLIENT_SECRET: 'c72c39a4dcff0b4d5d2924d86a30ecad634f642e1accfdff36cca5906bf4fe27',
};

export const CONSTANTS_CLINIC: ConstantsBaseClinic = {
  ...BASE_CONSTANTS,
  app_name: 'clinic',
  version: '__CLINIC_APP_VERSION__',
  x_service_code: 'BOOTS',
};

export const CONSTANTS_CMS_UI: EnvironmentBaseConstantsCMSUI = {
  ...BASE_CONSTANTS,
  app_name: 'cms',
  version: '__CMS_UI_APP_VERSION__',
  CLOUDFLARE_ACCESS_CLIENT_ID: 'a5659d47e0cfb7d8519ec671f05a2e8a.access',
  CLOUDFLARE_ACCESS_CLIENT_SECRET: 'c72c39a4dcff0b4d5d2924d86a30ecad634f642e1accfdff36cca5906bf4fe27',
};

export const SHARED_ENVIRONMENT_KEYS: Record<EnvironmentName, SharedThirdPartyKeys> = {
  localhost: {
    TOKBOX_API_KEY: '47810601',
    GOOGLE_MAPS_KEY: 'AIzaSyCwgdAgYI0uIANol1yNaGrVCX71ABoTo0k',
    STRIPE_API_KEY:
      'pk_test_51IQzhhEDx7XV6EhhvkoiZgTvkb1J25xnFfuBfbpwY0jGzEg0mYtRy57jj0I1F0qJCRKi38UoICQIF9v7vqYmFYlx00zqfURleR',
  },
  dev: {
    TOKBOX_API_KEY: '47810581',
    GOOGLE_MAPS_KEY: 'AIzaSyCwgdAgYI0uIANol1yNaGrVCX71ABoTo0k',
    STRIPE_API_KEY:
      'pk_test_51IQzhhEDx7XV6EhhvkoiZgTvkb1J25xnFfuBfbpwY0jGzEg0mYtRy57jj0I1F0qJCRKi38UoICQIF9v7vqYmFYlx00zqfURleR',
  },
  devphp8: {
    TOKBOX_API_KEY: '47810581',
    GOOGLE_MAPS_KEY: 'AIzaSyCwgdAgYI0uIANol1yNaGrVCX71ABoTo0k',
    STRIPE_API_KEY:
      'pk_test_51IQzhhEDx7XV6EhhvkoiZgTvkb1J25xnFfuBfbpwY0jGzEg0mYtRy57jj0I1F0qJCRKi38UoICQIF9v7vqYmFYlx00zqfURleR',
  },
  qa: {
    TOKBOX_API_KEY: '47810601',
    GOOGLE_MAPS_KEY: 'AIzaSyCwgdAgYI0uIANol1yNaGrVCX71ABoTo0k',
    STRIPE_API_KEY:
      'pk_test_51IQzhhEDx7XV6EhhvkoiZgTvkb1J25xnFfuBfbpwY0jGzEg0mYtRy57jj0I1F0qJCRKi38UoICQIF9v7vqYmFYlx00zqfURleR',
  },
  staging: {
    TOKBOX_API_KEY: '47810611',
    GOOGLE_MAPS_KEY: 'AIzaSyCwgdAgYI0uIANol1yNaGrVCX71ABoTo0k',
    STRIPE_API_KEY:
      'pk_test_51IQzhhEDx7XV6EhhvkoiZgTvkb1J25xnFfuBfbpwY0jGzEg0mYtRy57jj0I1F0qJCRKi38UoICQIF9v7vqYmFYlx00zqfURleR',
  },
  production: {
    TOKBOX_API_KEY: '47810621',
    GOOGLE_MAPS_KEY: 'AIzaSyCwgdAgYI0uIANol1yNaGrVCX71ABoTo0k',
    STRIPE_API_KEY:
      'pk_live_51IQzhhEDx7XV6Ehhjh4d0PfEviKSKFxKJR7OORrsv7w9AzUsnFjvUs5ekIOa3jYhDjoo8hGrv8LziSwCKqI7JLDo002mFVyoAt',
  },
} as const;

export const SHARED_ENVIRONMENT_API_URLS: Record<EnvironmentName, SharedApiUrls> = {
  localhost: {
    serverless_api_url: '/https/sapi/',
  },
  dev: {
    serverless_api_url: 'https://dev-sapi.lemonaidpims.co.uk/'
  },
  devphp8: {
    serverless_api_url: 'https://dev-sapi.lemonaidpims.co.uk/'
  },
  qa: {
    serverless_api_url: 'https://qa-sapi.lemonaidpims.co.uk/'
  },
  staging: {
    serverless_api_url: 'https://staging-sapi.lemonaidpims.co.uk/',
  },
  production: {
    serverless_api_url: 'https://sapi.lemonaidpims.co.uk/',
  },
} as const;
